import { render, staticRenderFns } from "./CMSViewComponent.vue?vue&type=template&id=2c2f2c51"
import script from "./CMSViewComponent.vue?vue&type=script&lang=js"
export * from "./CMSViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports